import type { FormikErrors, FormikTouched } from "formik";
export type {
    LeaveSaveOutcome,
    SaveBeforeLeaveResult,
} from "../core/saveBeforeLeaveOutcome";
export {
    isLeaveSaveSuccessful,
    normalizeSaveBeforeLeaveResult,
    toSaveBeforeLeaveResult,
} from "../core/saveBeforeLeaveOutcome";

/** Mark all keys present in `errors` as touched so validation messages display. */
export function touchAllFormikErrors<T>(
    errors: FormikErrors<T>,
    setTouched: (touched: FormikTouched<T>, shouldValidate?: boolean) => void
): void {
    if (!errors || typeof errors !== "object") return;

    const touched = Object.keys(errors).reduce((acc, key) => {
        acc[key as keyof T] = true as FormikTouched<T>[keyof T];
        return acc;
    }, {} as FormikTouched<T>);

    setTouched(touched, false);
}

export function hasFormikValidationErrors<T>(errors: FormikErrors<T>): boolean {
    return Object.keys(errors).length > 0;
}
